export const parseNumber = (value: string): number =>
  parseInt(value.replace(/\D/gm, ''), 10)
